import React from "react";
import Landing from "../components/Landing";
import Highlights from "../components/Highlights";
import Features from "../components/Featured";
import Featured from "../components/Featured";
import Discounted from "../components/Discounted";
import Explore from "../components/Explore";

const Home = () => {
  return (
    <>
      <Landing />
      <main>
        <Highlights />
        <Features />
        <Discounted />
        <Explore />
      </main>
    </>
  );
};

export default Home;

/*

      <Landing />
      <Highlights />
      <Featured />
      <Discounted />
      <Explore />
*/
